export function deduplicate<T>(arr: T[], keyProperty: keyof T) {
  const map = new Map();
  arr.forEach((element) => {
    map.set(element[keyProperty], element);
  });
  return [...map.values()];
}
